// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-wrapper .fc .fc-day-today {
  background: var(--aqua-color);
}
.calendar-wrapper .fc .fc-day-today .fc-col-header-cell-cushion {
  color: var(--grey-color);
}
.calendar-wrapper .fc .fc-col-header-cell-cushion {
  color: var(--pure-white-color);
}
.calendar-wrapper thead {
  background-color: var(--primary-color);
}`, "",{"version":3,"sources":["webpack://./src/component/pages/service-provider-admin/modules/appointment/calendar/Calendar.scss"],"names":[],"mappings":"AAIY;EACI,6BAAA;AAHhB;AAKgB;EACI,wBAAA;AAHpB;AAOY;EACI,8BAAA;AALhB;AAaQ;EACI,sCAAA;AAXZ","sourcesContent":["$calendarDays : (sun, mon, tue, wed, thu, fri, sat);\n\n.calendar-wrapper{\n        .fc {\n            .fc-day-today {\n                background: var(--aqua-color);  \n\n                .fc-col-header-cell-cushion{\n                    color: var(--grey-color);\n                }\n            }\n\n            .fc-col-header-cell-cushion{\n                color: var(--pure-white-color);\n            }\n\n            .fc-daygrid-event, .fc-timegrid-event{\n\n            }\n        }\n\n        thead{\n            background-color: var(--primary-color);\n        }\n      \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
